/**
 * @file  routes/config.ts
 * @description  defines the route to component mappings
 * @author ogarcia (ozkary)
 *
 */
import baseRoutes from '../../routes/baseConfig';

/**
 * @description add each route to component mappig below.
 */
const routes = [
  {
    path: ['/', '/login', '/home', '/vehicle', '/mileage'],
    exact: false,
    component: 'Welcome'
  },
  {
    path: ['/coverage'],
    exact: false,
    component: 'Coverages'
  },
  {
    path: ['/options'],
    exact: false,
    component: 'Options'
  }
];

// export the route mapping
export default routes;
export { baseRoutes };
